'use strict';
const _ = require('lodash');

let _biSession = createBiSession();

function createBiSession(biParams = {}) {
  return {
    get metaSiteId() {
      return biParams.metaSiteId;
    },
    get visitorId() {
      return biParams.visitorId;
    },
    get viewerSessionId() {
      return biParams.viewerSessionId;
    },
    get ownerId() {
      return biParams.ownerId;
    },
    get initialTimestamp() {
      return biParams.initialTimestamp;
    },
    set pageId(pageId) {
      biParams.pageId = pageId;
    },
    get pageId() {
      return biParams.pageId || '';
    },
    set pageUrl(pageUrl) {
      biParams.pageUrl = pageUrl;
    },
    get pageUrl() {
      return biParams.pageUrl || '';
    },
    get ts() {
      return Date.now() - biParams.initialTimestamp;
    },
    get postSSR() {
      return biParams.postSSR;
    },
    get requestId() {
      return biParams.requestId;
    }
  };
}

function initBiSession(biParams) {
  _biSession = createBiSession(biParams);
}

function getBiSession() {
  return _biSession;
}

function getBiSessionData() {
  const biSession = _.clone(_biSession);
  delete biSession.ts;
  delete biSession.tsn;
  return biSession;
}

module.exports = {
  initBiSession,
  getBiSession,
  getBiSessionData
};
